import classnames from 'classnames';
import React from 'react';
import IconContainer from './icon_container';

export default props => (
  <IconContainer viewBox="0 0 16 16" {...props} className={classnames('ticketIconContainer', props.className)}>
    <path d="M11.5 4H15V5.17071C13.8348 5.58254 13 6.69378 13 8C13 9.30622 13.8348 10.4175 15 10.8293V12H11.5V11C11.5 10.7239 11.2761 10.5 11 10.5C10.7239 10.5 10.5 10.7239 10.5 11V12L1 12V10.8293C2.16519 10.4175 3 9.30622 3 8C3 6.69378 2.16519 5.58254 1 5.17071V4H10.5V5C10.5 5.27614 10.7239 5.5 11 5.5C11.2761 5.5 11.5 5.27614 11.5 5V4ZM15.5 3C15.7761 3 16 3.22386 16 3.5V6C14.8954 6 14 6.89543 14 8C14 9.10457 14.8954 10 16 10V12.5C16 12.7761 15.7761 13 15.5 13L0.5 13C0.223858 13 0 12.7761 0 12.5V10C1.10457 10 2 9.10457 2 8C2 6.89543 1.10457 6 0 6V3.5C0 3.22386 0.223859 3 0.500001 3H15.5ZM11.5 7C11.5 6.72386 11.2761 6.5 11 6.5C10.7239 6.5 10.5 6.72386 10.5 7V9C10.5 9.27614 10.7239 9.5 11 9.5C11.2761 9.5 11.5 9.27614 11.5 9V7Z" />
  </IconContainer>
);



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/lib/icons/ticket_icon.jsx